<div class="parallax" />

<style>
    .parallax {
        background-image: url("https://images.unsplash.com/photo-1458668383970-8ddd3927deed?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3000&q=80");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: center;

        z-index: 1;
        height: 250px;
        width: 100%;
    }

    @media screen and (max-width: 900px) {
        .parallax {
            height: 150px;
        }
    }
</style>
